module.exports = __webpack_public_path__ + "img/second-outer.cc11d3e8.svg";